import * as c from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { SearchButtonIcon } from 'src/assets/icons/nav/search-button.icon'

type SearchButtonProp = {
  label: string
  width: string
  maxHeight: string
  pt: string
  pb: string
  pr: string
  pl: string
  bg: string
}

const SearchButton = ({
  label,
  maxHeight,
  width,
  pt,
  pb,
  pr,
  pl,
  bg,
}: SearchButtonProp) => {
  const navigate = useNavigate()

  return (
    <c.Flex
      onClick={() => navigate('/search')}
      minH="full"
      maxH={maxHeight}
      w={width}
      textDecoration="none"
      bg={bg}
      pt={pt}
      pb={pb}
      pr={pr}
      pl={pl}
      justify="space-between"
      border="none"
      alignItems="center"
      borderRadius="200px"
      transition="all 0.2s ease-in-out"
      _hover={{
        background: 'black.50',
      }}
    >
      <c.Text
        color="black.500"
        fontSize="0.75rem"
        fontWeight="bold"
        textAlign="start"
        m={0}
      >
        {label}
      </c.Text>

      <SearchButtonIcon />
    </c.Flex>
  )
}

export default SearchButton
